import { render } from "./menu-top.vue?vue&type=template&id=086cb16e"
import script from "./menu-top.vue?vue&type=script&lang=js"
export * from "./menu-top.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__